import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Performance / éclair — productivité duotone */
export const PerformanceIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Éclair rempli menthe */}
      <path
        d="M13 2L4 14h6l-1 8 9-12h-6l1-8z"
        fill="var(--equiply-icon-bg)"
      />
      {/* Contour bleu */}
      <path
        d="M13 2L4 14h6l-1 8 9-12h-6l1-8z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
    </svg>
  ),
);
PerformanceIcon.displayName = "PerformanceIcon";
